import { NavigationMenuTypeEnum } from './navigation-menu-type-enum';

export class UserNavigationResult {
    private ok: boolean;
    private statusCode: number;
    private statusText: string;
    private navigation: any;
    private navigationMenuLevel: NavigationMenuTypeEnum;

    constructor(ok: boolean, status: number, statusText: string, userNavigation: any, menuLevel: NavigationMenuTypeEnum) {
        this.ok = ok;
        this.statusCode = status;
        this.statusText = statusText;
        this.navigation = userNavigation;
        this.navigationMenuLevel = menuLevel;
    }

    get Ok(): boolean { return this.ok; }

    get Status(): number { return this.statusCode; }
    set Status(value: number) { this.statusCode = value; }

    get StatusText(): string { return this.statusText; }
    set StatusText(value: string) { this.statusText = value; }

    get NavigationMenuLevel(): NavigationMenuTypeEnum { return this.navigationMenuLevel; }
    set NavigationMenuLevel(value: NavigationMenuTypeEnum) { this.navigationMenuLevel = value; }

    get UserNavigation(): any {
        return this.navigation;
    }
}
